import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box22_ResubmissionCode: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Box display="flex" gap={1}>
        <Box display="flex" flexDirection="column" gap={1} flex={1}>
          <Typography variant="caption">22. RESUBMISSION CODE</Typography>
          <Controller
            name="resubmissionCode"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                fullWidth
              />
            )}
          />
        </Box>
        <Box display="flex" flexDirection="column" gap={1} flex={1}>
          <Typography variant="caption">ORIGINAL REF. NO.</Typography>
          <Controller
            name="originalRefNo"
            control={control}
            render={({ field, fieldState }) => (
              <ClaimTextField
                field={field}
                fieldState={fieldState}
                size="small"
                fullWidth
              />
            )}
          />
        </Box>
      </Box>
    </>
  );
};